<div class="best-tickets">
  <div class="best-tickets-header hidden" role="best-tickets-header">{% unsafe __('best_tickets.header') %}</div>
  <div role="best-tickets-container"></div>
</div>
